import { useAuth } from './useAuth';
import { supabase } from '@/integrations/supabase/client';
import { useQuery } from '@tanstack/react-query';

export function useAdmin() {
    const { user, loading: authLoading } = useAuth();

    const { data: isAdmin, isLoading: adminLoading } = useQuery({
        queryKey: ['isAdmin', user?.id],
        queryFn: async () => {
            if (!user) return false;
            // The is_admin function accepts an optional user_uuid parameter.
            // If checking for yourself (current user), you can pass null or user.id
            const { data, error } = await supabase.rpc('is_admin', { user_uuid: user.id });
            if (error) {
                console.error("Error checking admin status:", error);
                return false;
            }
            return !!data;
        },
        enabled: !!user,
        staleTime: 1000 * 60 * 5, // Cache result for 5 minutes
    });

    return {
        isAdmin: !!isAdmin,
        loading: authLoading || (!!user && adminLoading)
    };
}
